import {
  getMCBOS010CopyRequest,
  getMCBOS010InitRequest,
  getMCBOS010Register,
  getMCBOS010UpdateRequest,
  mCBOS010BulkOperationRequest,
  updateDisplayOrderRequest,
} from 'apis/MCBOS010Api'
import { doCreateApi, initCheckApi } from 'apis/MCBOS020Api'
import { openSnackbar, openModal } from 'reducers/messageReducer'
import { 
    doDeleteApi,
    doUpdateApi,
    getUpdateInitialValuesApi 
} from 'apis/MCBOS030Api'
import {
  setCreateDialogOpen,
  setCopy,
  doCreate,
  doDelete,
  doUpdate,
  setUpdateDialogOpen,
  setUpdateValues,
  setInitMCBOS010,
  updateSelectionFileManagementFlagDisplayOrder,
  checkCopyRequest,
  checkRegisterRequest,
  checkUpdateRequest,
  fetchInitMCBOS010,
  updateSelectionFileManagement,
  setInitMCBOS020,
  fetchInitMCBOS020,
} from 'reducers/selectionFileManagementReducer'
import { all, call, put, takeEvery, takeLeading } from 'redux-saga/effects'
import { MCBOS020CreateRequest } from 'types/MCBOS020/MCBOS020CreateRequest'
import { magiContants } from 'utils/contants'
import { MCBOS010InitResponse } from 'types/MCBOS010/MCBOS010InitRequest'
import { PayloadAction } from '@reduxjs/toolkit'
import { getMessage } from 'common/messageUtil'
import { MCBOS010BulkOperationRequest } from 'types/MCBOS010/MCBOS010BulkOperationRequest'
import { MCBOS010CopyRequest } from 'types/MCBOS010/MCBOS010CopyRequest'
import { MCBOS010DisplayOrderRequest } from 'types/MCBOS010/MCBOS010DisplayOrderRequest'
import { MCBOS010UpdateRequest } from 'types/MCBOS010/MCBOS010UpdateRequest'
import { MCBOS020InitRequest } from 'types/MCBOS020/MCBOS020InitRequest'
import { MCBOS020InitResponse } from 'types/MCBOS020/MCBOS020InitResponse'

function* doCreateSaga(action: ReturnType<typeof doCreate>) {
  try {
    const createData: MCBOS020CreateRequest = {
      selectionFileName: action.payload.selectionFileName,
      targetYear: action.payload.targetYear,
    }

    yield call(doCreateApi, createData)
    yield put(setCreateDialogOpen(false))

    const response: MCBOS010InitResponse = yield call(getMCBOS010InitRequest);
    const transformedList = response.selectionFileNameItemsInfoList.map(item => ({
      selectionFileManagementId: item.selectionFileManagementId,
      selectionFilename: item.selectionFilename,
      displayOrder: item.displayOrder,
      updater: item.updater,
      updateTime: item.updateTime,
      sysVersionNumber: item.sysVersionNumber
    }));

    yield put(setInitMCBOS010({
      selectionManagementOptionValidStatus: response.selectionManagementOptionValidStatus,
      maxSelectionFileNameCount: response.maxSelectionFileNameCount,
      batchOperationOptionItemsInfo: response.batchOperationOptionItemsInfo,
      selectionFileNameItemsInfoList: transformedList
    }));
    
    yield put(openSnackbar(magiContants.MESSAGECODE_MCBOS020_007))

  } catch (error) {
    yield put(openModal(error.message))
  }
}

function* doUpdateSaga(action: ReturnType<typeof doUpdate>) {
  try {

    const updateData = {
      selectionFileName: action.payload.selectionFileName,
      targetYear: action.payload.targetYear,
      selectionFileManagementId: action.payload.selectionFileManagementId,
      sysVersionNumber: action.payload.sysVersionNumber
    }

    yield call(doUpdateApi, updateData)
    yield put(setUpdateDialogOpen(false))

    const response: MCBOS010InitResponse = yield call(getMCBOS010InitRequest);
    const transformedList = response.selectionFileNameItemsInfoList.map(item => ({
      selectionFileManagementId: item.selectionFileManagementId,
      selectionFilename: item.selectionFilename,
      displayOrder: item.displayOrder,
      updater: item.updater,
      updateTime: item.updateTime,
      sysVersionNumber: item.sysVersionNumber
    }));

    yield put(setInitMCBOS010({
      selectionManagementOptionValidStatus: response.selectionManagementOptionValidStatus,
      maxSelectionFileNameCount: response.maxSelectionFileNameCount,
      batchOperationOptionItemsInfo: response.batchOperationOptionItemsInfo,
      selectionFileNameItemsInfoList: transformedList
    }));

    yield put(openSnackbar(getMessage('MCBOS030-007')));

    } catch (error) {
    yield put(openModal(error.message))
  }
}

function* doDeleteSaga(action: ReturnType<typeof doDelete>) {
  try {

    const deleteData = {
      selectionFileManagementId: action.payload.selectionFileManagementId,
      sysVersionNumber: action.payload.sysVersionNumber
    }

    yield call(doDeleteApi, deleteData)
    yield put(setUpdateDialogOpen(false))

    const response: MCBOS010InitResponse = yield call(getMCBOS010InitRequest);
    const transformedList = response.selectionFileNameItemsInfoList.map(item => ({
      selectionFileManagementId: item.selectionFileManagementId,
      selectionFilename: item.selectionFilename,
      displayOrder: item.displayOrder,
      updater: item.updater,
      updateTime: item.updateTime,
      sysVersionNumber: item.sysVersionNumber
    }));

    yield put(setInitMCBOS010({
      selectionManagementOptionValidStatus: response.selectionManagementOptionValidStatus,
      maxSelectionFileNameCount: response.maxSelectionFileNameCount,
      batchOperationOptionItemsInfo: response.batchOperationOptionItemsInfo,
      selectionFileNameItemsInfoList: transformedList
    }));

    yield put(openSnackbar(getMessage('MCBOS030-009')));

  } catch (error) {
    yield put(openModal(error.message))
  }
}

function* getInitListSaga() {
  try {
    const response: MCBOS010InitResponse = yield call(getMCBOS010InitRequest);

    const transformedList = response.selectionFileNameItemsInfoList.map(item => ({
      selectionFileManagementId: item.selectionFileManagementId,
      selectionFilename: item.selectionFilename,
      displayOrder: item.displayOrder,
      updater: item.updater,
      updateTime: item.updateTime,
      sysVersionNumber: item.sysVersionNumber
    }));

    yield put(setInitMCBOS010({
      selectionManagementOptionValidStatus: response.selectionManagementOptionValidStatus,
      maxSelectionFileNameCount: response.maxSelectionFileNameCount,
      batchOperationOptionItemsInfo: response.batchOperationOptionItemsInfo,
      selectionFileNameItemsInfoList: transformedList
    }));

  } catch (error) {
    console.error('Failed to fetch MCBOS010 data:', error);
  }
}

function* updateSelectionFileManagementSaga(action: PayloadAction<{
  selectionFileManagementId: number[]
  year: string
  versionNumber: number[]
}>) {
  try {
    const requestData: MCBOS010BulkOperationRequest = {
      selectedBatchOperationOption: [action.payload.year],
      selectionFileManagementId: action.payload.selectionFileManagementId,
      versionNumber: action.payload.versionNumber,
    };
    yield call(mCBOS010BulkOperationRequest, requestData);
    yield put(openSnackbar(getMessage('MCBOS010-007')));
  } catch (error) {
    const msgSplit = error.message.split(',');
    const msgCode = msgSplit[0];
    const msgArgs = [msgSplit.slice(1).join(', ')];

    yield put(openModal(getMessage(msgCode, msgArgs)));
  }
}

function* updateDisplayOrderSaga(
  action: ReturnType<typeof updateSelectionFileManagementFlagDisplayOrder>
) {

  try {
    let updateOrders: MCBOS010DisplayOrderRequest = {
      selectionFileManagementId: [],
      versionNumber: [],
    };

    action.payload.forEach((item, index) => {
      updateOrders.selectionFileManagementId.push(item.selectionFileManagementId);
      updateOrders.versionNumber.push(item.sysVersionNumber);
    });

    yield call(updateDisplayOrderRequest, updateOrders);

    const response = yield call(getMCBOS010InitRequest);
    const transformedData = {
      selectionManagementOptionValidStatus: response.selectionManagementOptionValidStatus,
      maxSelectionFileNameCount: response.maxSelectionFileNameCount,
      batchOperationOptionItemsInfo: response.batchOperationOptionItemsInfo,
      selectionFileNameItemsInfoList: response.selectionFileNameItemsInfoList
    };

    yield put(setInitMCBOS010(transformedData));

  } catch (error) {
    yield put(openModal(error.message));
  }
}

function* checkRegisterApiSaga(action: PayloadAction<{
  yearDeterminingMediaFlag: string
}>) {
  try {
    yield call(getMCBOS010Register);

    const initData: MCBOS020InitRequest = {
      selectionFileManagementId: 0,
      versionNumber: 0,
      yearDeterminingMediaFlag: action.payload.yearDeterminingMediaFlag,
    }

    const apiData = yield call(initCheckApi, initData);

    const clearData = {
      selectionFileManagementId: [0],
      selectionFileName: '',
      targetYear: apiData.yearDeterminingMediaFlag,
      targetYearList: [''],
    }

    yield put(setCreateDialogOpen(true))
    yield put(setCopy(clearData))

    yield put(setCreateDialogOpen(true));

  } catch (error) {
    yield put(openModal(getMessage(error.message)));
  }
}

function* checkUpdateRequestSaga(action: PayloadAction<{ id: number, versionNumber: number}>) {
  const { id, versionNumber } = action.payload;

  try {
    const checkUpdateRequestData: MCBOS010UpdateRequest = {
      selectionFileManagementId: [id],
      versionNumber: [versionNumber],
    };

    yield call(getMCBOS010UpdateRequest, checkUpdateRequestData);

    const initValueRequest = {
      selectionFileManagementId: id,
    }

    const data = yield call(getUpdateInitialValuesApi, initValueRequest)

    const editData = {
      selectionFileName: data.selectionFileName,
      targetYear: data.yearDeterminingMediaFlag,
      selectionFileManagementId: data.selectionFileManagementId,
      sysVersionNumber: data.sysVersionNumber,
    }

    yield put(setUpdateDialogOpen(true))
    yield put(setUpdateValues(editData))

  } catch (error) {
    yield put(openModal(getMessage(error.message)));
  }
}

function* checkCopyRequestSaga(action: PayloadAction<{
  id: number,
  versionNumber: number
  yearDeterminingMediaFlag: string
}>) {
  const {
    id,
    versionNumber,
  } = action.payload;
  
  try {
    const requestData: MCBOS010CopyRequest = {
      selectionFileManagementId: [id],
      versionNumber: [versionNumber],
    };
    
    yield call(getMCBOS010CopyRequest, requestData);
    const initData: MCBOS020InitRequest = {
      selectionFileManagementId: action.payload.id,
      versionNumber: action.payload.versionNumber,
      yearDeterminingMediaFlag: action.payload.yearDeterminingMediaFlag,
    }

    const data = yield call(initCheckApi, initData)
    const copyData = {
      selectionFileManagementId: requestData.selectionFileManagementId,
      selectionFileName: data.selectionFileName,
      targetYear: data.yearDeterminingMediaFlag,
      targetYearList: data.targetYearList,
    }

    yield put(setCreateDialogOpen(true))
    yield put(setCopy(copyData))
      
  } catch (error) {
    yield put(openModal(getMessage(error.message)));
  }
}

function* getInitMCBOS020Saga(
  action: PayloadAction<{ yearDeterminingMediaFlag: string }>
) {
  try {
    const initData: MCBOS020InitRequest = {
      selectionFileManagementId: 0,
      versionNumber: 0,
      yearDeterminingMediaFlag: action.payload.yearDeterminingMediaFlag,
    };

    const response: MCBOS020InitResponse = yield call(initCheckApi, initData);
    yield put(setInitMCBOS020(response));

  } catch (error) {
    yield put(openModal(getMessage(error.message)));
  }
}



export default function* selectionFileManagementSaga() {
  yield all([
    takeLeading(doCreate, doCreateSaga),
    takeLeading(doUpdate, doUpdateSaga),
    takeLeading(doDelete, doDeleteSaga),
    takeEvery(fetchInitMCBOS010, getInitListSaga),
    takeEvery(updateSelectionFileManagement.type, updateSelectionFileManagementSaga),
    takeEvery(updateSelectionFileManagementFlagDisplayOrder.type, updateDisplayOrderSaga),
    takeEvery(checkRegisterRequest, checkRegisterApiSaga),
    takeEvery(checkUpdateRequest, checkUpdateRequestSaga),
    takeEvery(checkCopyRequest, checkCopyRequestSaga),
    takeEvery(fetchInitMCBOS020, getInitMCBOS020Saga),
  ])
}
